var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiscourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8A7.5 7.5 0 018 15.5H.5V8a7.5 7.5 0 0115 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.92 12.513a4.266 4.266 0 10-6.427-2L3.58 12.42l2.113-.187a4.26 4.26 0 005.227.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.487 5.08a4.267 4.267 0 112 6.427l-1.907.913.187-2.113a4.26 4.26 0 01-.28-5.227"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggZD0iTTE1LjUgOEE3LjUgNy41IDAgMCAxIDggMTUuNUguNVY4YTcuNSA3LjUgMCAwIDEgMTUgMCIvPjxwYXRoIGQ9Ik0xMC45MiAxMi41MTNhNC4yNjYgNC4yNjYgMCAxIDAtNi40MjctMkwzLjU4IDEyLjQybDIuMTEzLS4xODdhNC4yNiA0LjI2IDAgMCAwIDUuMjI3LjI4Ii8+PHBhdGggZD0iTTMuNDg3IDUuMDhhNC4yNjcgNC4yNjcgMCAxIDEgMiA2LjQyN2wtMS45MDcuOTEzLjE4Ny0yLjExM2E0LjI2IDQuMjYgMCAwIDEtLjI4LTUuMjI3Ii8+PC9nPjwvc3ZnPg==";
export { SvgIconDiscourse as ReactComponent };